import { styled } from '@linaria/react';
import React, { useEffect, useState } from 'react';
import LinkListItem from '../LinkListItem';

const StyledMenu = styled.ul`
  flex-wrap: wrap;
  list-style: none;
  margin-top: 0.5rem;

  a,
  div {
    display: inline-flex;
    text-decoration: none;
    line-height: 1rem;
    letter-spacing: 1.5px;
  }

  a {
    &:hover {
      text-decoration: underline;
    }

    svg + svg {
      display: none;
    }
  }
`;

export interface ParagraphProps extends Paragraph {
  link: LinkProps;
  menu: [LinkProps];
}

interface ParagraphMenuProps {
  node: ParagraphProps;
  props?: {
    location?: string;
  };
}

const ParagraphMenu: React.FC<DeepReadonly<ParagraphMenuProps>> = function ({ node, props }) {
  const [isLargeScreen, setIsLargeScreen] = useState(true);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const check = () => setIsLargeScreen(window.matchMedia('(min-width: 992px)').matches);
      check();

      window.addEventListener('resize', check);
      return () => window.removeEventListener('resize', check);
    }
    return undefined;
  }, []);

  const { menu, behavior_settings, link: headerLink } = node;
  const classes = behavior_settings?.decoupled_styles?.classes || [];
  const allClasses = [...classes, 'menu'];
  const isFooter = props?.location === 'footer';
  let dlEvent: Object | undefined;

  return (
    <StyledMenu className={allClasses.join(' ')} node={node}>
      {headerLink && <LinkListItem link={headerLink} />}

      {menu.map((link, index) => {
        if (isFooter) {
          dlEvent = {
            event: 'nav_click',
            event_params: {
              nav_item: link.title,
              nav_type: 'footer',
            },
          };
        }

        if (!isFooter && !isLargeScreen) return null;

        return (
          <LinkListItem
            key={`${link.title}-${index}`}
            link={link}
            border={isFooter && index !== menu.length - 1}
            center={isFooter}
            dlEvent={dlEvent}
            section={props?.location}
          />
        );
      })}
    </StyledMenu>
  );
};

export default ParagraphMenu;
